import React from 'react';
import { ApButtonLink } from '@alixpartners/ui-components';

import {
  ContentBlock,
  CostValue,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../BuildReports.styles';

import { generateEtPowerBiProLicenseMail } from '../../../../utils/mailTo';

interface IPowerBiProLicenseSectionProps {
  powerBiWorkspaceUrl: string;
  userName: string;
}
export const PowerBiProLicenseSection = ({
  powerBiWorkspaceUrl,
  userName,
}: IPowerBiProLicenseSectionProps) => {
  return (
    <SectionWrapper animationIndex={1}>
      <Title>Your Power BI Pro license</Title>
      <ContentBlock>
        <Description>
          If you have your license but have never used Power BI before, please
          activate your license by open the Power BI Workspace and log in into
          the system.
        </Description>
        <RightSection>
          <RightSectionColumn>
            <CostValue>
              <ApButtonLink
                target="_blank"
                href={generateEtPowerBiProLicenseMail(userName)}
                rel="noopener noreferrer"
              >
                Request Power BI Pro License
              </ApButtonLink>
            </CostValue>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
      <ContentBlock>
        <Description>
          You must have a Power BI Pro license to publish or/and view reports on
          your Power BI Workspace. AlixPartners should have allocated you a
          license already.
          <br />
          If you don&#39;t have a Power BI Pro license, you can request it now.
        </Description>
        <RightSection>
          <RightSectionColumn>
            <CostValue>
              <ApButtonLink
                target="_blank"
                href={powerBiWorkspaceUrl}
                rel="noopener noreferrer"
              >
                Open Power BI Workspace
              </ApButtonLink>
            </CostValue>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
